if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor(modalId = 'product-modal') {
        super();
        this.modalId = modalId;
        this.initObjects();
        this.addEventListener('click', (event) => { this.hideOverlay() });
        this.addEventListener('keydown', (event) => {
          if (event.code === 'Escape') this.hide();
        });
        window.overlayManager.subscribe(this.modalId, this);
        subscribe(PUB_SUB_EVENTS.siteLoaded, () => {
          this.initObjects();
        });
      }
      
      hideOverlay() {
        window.overlayManager.close(this.modalId);
      }

      initObjects() {
        this.mediaGallery = document.querySelector('[id^="MediaGallery-ProductGallery"]');
        if (!this.mediaGallery) return;
        this.slider = this.mediaGallery.querySelector('[id^="GalleryViewer"]');
        this.buttons = this.slider.querySelectorAll("button.product__media-toggle");
        this.allowMagnify = this.slider.classList.contains('media-gallery-zoom-gallery') // || this.slider.classList.contains('media-gallery-zoom-lightbox');
      }

      close() {
        super.hide();
        if (this.allowMagnify || window.innerWidth < 750) {
          this.slider?.classList.remove('zoomed-in-modal');
          this.buttons?.forEach(button => button.classList.remove('zoomed-in-modal'));
          this.mediaGallery && this.mediaGallery.classList.remove('zoomed-in-modal');
          this.mediaGallery && this.mediaGallery.removeAllMagnifications();
          this.slider && this.slider.classList.remove('zoom-magnified');
          if(!this.headerWrapper) this.headerWrapper = document.querySelector('header-wrapper');
          this.headerWrapper.style.zIndex = '';
        }
      }
      hide() {
        if (this.allowMagnify || window.innerWidth < 750) return;
        super.close();

      }

      async scrollSlider() {
        const slideElement = this.openedBy && this.openedBy.closest('[id^="Slide-template-"]');
        if (!slideElement) return;
        const slider = this.openedBy.closest('[id^="Slider-"]');
        this.slider.slideToShow = slideElement;
      }
      show(opener) {
        this.opener = opener;
        window.overlayManager.open(this.modalId);
      }
      open() {
        if(!this.headerWrapper) this.headerWrapper = document.querySelector('header-wrapper');
        this.headerWrapper.style.zIndex = '-1';
        super.show(this.opener);
        this.scrollSlider();
        if (this.allowMagnify || window.innerWidth < 750) {
          if (this.slider.classList.contains('zoomed-in-modal')) {
          } else {
            this.slider.classList.add('zoomed-in-modal');
            this.buttons.forEach(button => button.classList.add('zoomed-in-modal'));
            this.mediaGallery.classList.add('zoomed-in-modal');
            setTimeout(() => {
              this.slider.initPages();
            });
          }
        }
      }
    }
  );
}